function get(key) {
  return localStorage.getItem(key);
}

function set(key, data) {
  localStorage.setItem(key, data);
}

function clear(key) {
  localStorage.removeItem(key);
  return;
}
export default {
  get,
  set,
  clear,
};
